module.exports = __webpack_public_path__ + "img/About-Cover-Photo.6cdcbf67.png";